import React, { useEffect, useState } from 'react';
import { Bar, Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend } from 'chart.js';
import api from '../api/axios';

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend);

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/dashboard/stats/').then(res => setStats(res.data)).catch(console.error);
  }, []);

  if (!stats) return <div>Loading dashboard...</div>;

  const fmt = (n) => Number(n || 0).toLocaleString('en-KE', { style: 'currency', currency: 'KES', maximumFractionDigits: 0 });

  const revenueChart = {
    labels: stats.by_sub_county.map(s => s.sub_county),
    datasets: [{
      label: 'Revenue (KES)',
      data: stats.by_sub_county.map(s => Number(s.revenue || 0)),
      backgroundColor: ['#1a5632', '#2d8a56', '#45b77a', '#6dd49e', '#95ebc2'],
    }]
  };

  const paymentChart = {
    labels: stats.by_payment_mode.map(p => p.mode_of_payment || 'N/A'),
    datasets: [{
      data: stats.by_payment_mode.map(p => p.count),
      backgroundColor: ['#1a5632', '#e6a817', '#2196F3', '#9e9e9e'],
    }]
  };

  return (
    <div>
      <div className="page-header"><h1>Dashboard</h1></div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="label">Total Businesses</div>
          <div className="value">{stats.total_businesses.toLocaleString()}</div>
        </div>
        <div className="stat-card">
          <div className="label">Total Revenue</div>
          <div className="value">{fmt(stats.total_revenue)}</div>
        </div>
        <div className="stat-card">
          <div className="label">Sub Counties</div>
          <div className="value">{stats.by_sub_county.length}</div>
        </div>
        <div className="stat-card">
          <div className="label">Business Types</div>
          <div className="value">{stats.by_nature.length}+</div>
        </div>
      </div>

      <div className="chart-grid">
        <div className="card">
          <h3 style={{marginBottom:'16px',fontSize:'15px'}}>Revenue by Sub County</h3>
          <Bar data={revenueChart} options={{ responsive: true, plugins: { legend: { display: false } } }} />
        </div>
        <div className="card">
          <h3 style={{marginBottom:'16px',fontSize:'15px'}}>Payment Methods</h3>
          <Doughnut data={paymentChart} options={{ responsive: true }} />
        </div>
      </div>

      <div className="card">
        <h3 style={{marginBottom:'12px',fontSize:'15px'}}>Top Business Types</h3>
        <table className="data-table">
          <thead><tr><th>Nature of Business</th><th>Count</th></tr></thead>
          <tbody>
            {stats.by_nature.map((n, i) => (
              <tr key={i}><td>{n.nature_of_business || 'N/A'}</td><td>{n.count}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
